import { graphql } from 'GQL/gql';

const GET_VIEWER = graphql(`
  query GET_VIEWER {
    viewer {
      _id
      permissions
      profile {
        firstName
        lastName
        avatar
        email
        nationality {
          code
          name
        }
        workPermit {
          id
          name
        }
      }
      isSsoUser
      isMaster
      countryCode
      lastSelectedLanguage
      notificationsSettings {
        hasPersonalDevelopmentEnabled
        hasTopMatchEnabled
      }
      badges {
        id
        name
        image
        link
        skillIds
      }
      rights {
        capabilityCanPublish
      }
    }
  }
`);

export { GET_VIEWER };
